<template>
  <div id="root"></div>
</template>

<script>
import store from "../../store/index.js"
export default {
  name: "ZegoCall",
  props: {
    meetingId: {
      type: String,
      required: true
    }
  },
  methods: {
    getUrlParams(url) {
      let urlStr = url.split('?')[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    initializeZegoRoom() {
      const params = this.getUrlParams(window.location.href);

      const roomID = this.meetingId || params['roomID'] || (Math.floor(Math.random() * 10000) + "");
      const userID = Math.floor(Math.random() * 10000) + "";
      const userName = store.getters.username|| "user" + userID;

      const appID = Number(process.env.VUE_APP_ZEGO_LIVE_APP_ID)
      const serverSecret = process.env.VUE_APP_ZEGO_LIVE_SERVER_SECRET
      
      const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
        appID,
        serverSecret,
        roomID,
        userID,
        userName
      );

      const zp = ZegoUIKitPrebuilt.create(kitToken);
      zp.joinRoom({
        container: document.querySelector("#root"),
        sharedLinks: [{
          name: 'Personal link',
          url:
            window.location.protocol + '//' +
            window.location.host +
            window.location.pathname +
            '?roomID=' + roomID,
        }],
        scenario: {
          mode: ZegoUIKitPrebuilt.VideoConference
        },
        turnOnMicrophoneWhenJoining: true,
        turnOnCameraWhenJoining: false,
        showMyCameraToggleButton: false,
        showMyMicrophoneToggleButton: true,
        showAudioVideoSettingsButton: true,
        showScreenSharingButton: true,
        showTextChat: true,
        showUserList: true,
        layout: "Grid",
        showLayoutButton: true,
      });
    }
  },
  mounted() {
    this.initializeZegoRoom();
  }
};
</script>

<style scoped>
/* 100% rather than 100vw: vw includes the scrollbar and causes horizontal overflow */
#root {
  width: 100%;
  height: 100vh;
}
</style>
